function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  keysSortedByValueDescriptors
} = require('@truqc/content-path');
const clone = data => JSON.parse(JSON.stringify(data));

/**
 *
 * @method showItemIfValueToVisible - this method maps the
 * "showItemIfVisible" property (if it exists) on a collection
 * into an evaluatable "visible" property using formulas.
 *
 * Eventually, this will go away, and we will just use the visible
 * property, but this gets us over the hump for now.
 */
const showItemIfValueToVisible = showFormat => {
  const result = {};
  const {
    atChildContentPath,
    equals,
    equalsOneOf,
    equalsNoneOf
  } = showFormat;
  const pathType = typeof atChildContentPath;
  const multiPaths = pathType === 'array' || pathType === 'string' && atChildContentPath.includes('*');
  let childValue;
  if (multiPaths) {
    childValue = {
      type: 'readContentValuesBehavior',
      sourceContentPaths: [atChildContentPath],
      defaultValue: []
    };
  } else {
    childValue = {
      type: 'readContentValueBehavior',
      sourceContentPath: atChildContentPath,
      defaultValue: ''
    };
  }
  if (equals !== undefined) {
    if (multiPaths) {
      result.visible = {
        type: 'isMemberOfBehavior',
        source: childValue,
        compareValue: `${equals}`
      };
    } else {
      result.visible = {
        type: 'formulaBehavior',
        formula: `childValue == ${JSON.stringify(equals)}`,
        variables: {
          childValue
        }
      };
    }
  } else if (equalsNoneOf !== undefined) {
    const subpredicates = [];
    let variables = {};
    if (multiPaths) {
      equalsNoneOf.forEach((equalsItem, index) => {
        const varName = `item${index}`;
        variables[varName] = {
          type: 'isMemberOfBehavior',
          source: childValue,
          compareValue: `${equalsItem}`
        };
        subpredicates.push(`not ${varName}`);
      });
    } else {
      variables = {
        childValue
      };
      equalsNoneOf.forEach(equalsItem => {
        subpredicates.push(`childValue != ${JSON.stringify(equalsItem)}`);
      });
    }
    result.visible = {
      type: 'formulaBehavior',
      formula: subpredicates.join(' and '),
      variables
    };
  } else if (equalsOneOf !== undefined) {
    const subpredicates = [];
    let variables = {};
    if (multiPaths) {
      equalsOneOf.forEach((equalsItem, index) => {
        const varName = `item${index}`;
        variables[varName] = {
          type: 'isMemberOfBehavior',
          source: childValue,
          compareValue: `${equalsItem}`
        };
        subpredicates.push(varName);
      });
    } else {
      variables = {
        childValue
      };
      equalsOneOf.forEach(equalsItem => {
        subpredicates.push(`childValue == ${JSON.stringify(equalsItem)}`);
      });
    }
    result.visible = {
      type: 'formulaBehavior',
      formula: subpredicates.join(' or '),
      variables
    };
  } else {
    result.visible = {
      type: 'isDefinedBehavior',
      source: `@{${atChildContentPath}}`
    };
  }
  return result;
};

/**
 * Wraps an already expanded collection to provide a
 * a label if one is needed.
 */
const expandWithLabel = (container, format) => {
  if (format === undefined) {
    return undefined;
  }
  if (format.labelContentPath !== undefined) {
    return {
      type: 'v1Container',
      children: [{
        type: 'label',
        labelContentPath: format.labelContentPath
      }, container]
    };
  }
  return container;
};

/**
 * expand a single collection with data from items in the collection.
 */
const expandSingleCollection = (collectionFormat, itemDictionary, containerType) => {
  const {
    ascending = true,
    children,
    childWidth,
    showItemIfValue,
    showDivider,
    itemLabel,
    breakable,
    sort = [{
      path: '_created',
      ascending
    }]
  } = collectionFormat;
  // this holds all a single instance of the collection -
  // there will be one of these for each item in the collection.
  let child = {
    children: clone(children),
    dontBreak: !breakable,
    type: containerType,
    mdWidth: childWidth
  };
  // contain all the collection item in this.
  const result = _objectSpread(_objectSpread({}, collectionFormat), {}, {
    type: containerType,
    dontBreak: false,
    children: []
  });

  // handle these props uniquely down in the children
  delete result.itemLabel;
  delete result.showDivider;
  delete result.showItemIfValue;
  const extraFormat = {};
  if (showItemIfValue !== undefined) {
    const showFormat = showItemIfValueToVisible(showItemIfValue);
    // wrap child with visibility properties
    child = _objectSpread(_objectSpread({}, child), showFormat);
    child = {
      type: containerType,
      dontBreak: !breakable,
      children: [child]
    };
  }
  if (typeof itemDictionary === 'undefined') {
    return result;
  }
  const sortedKeys = keysSortedByValueDescriptors(itemDictionary, sort);
  sortedKeys.forEach((itemID, index, arr) => {
    const newkid = clone(_objectSpread(_objectSpread(_objectSpread({}, extraFormat), child), {}, {
      contentPath: itemID
    }));
    if (itemLabel !== undefined) {
      const itemNumber = ascending === false ? arr.length - index : index + 1;
      newkid.children.unshift({
        type: 'label',
        label: `${itemLabel} ${itemNumber}`
      });
    }
    if (showDivider === true && index > 0) {
      newkid.children.unshift({
        type: 'row',
        children: [{
          type: 'divider'
        }]
      });
    }
    result.children.push(newkid);
  });
  return result;
};
module.exports = {
  expandSingleCollection,
  expandWithLabel,
  showItemIfValueToVisible
};